module.exports = __webpack_public_path__ + "static/media/xpress-non-favorite-game.389efc52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/xpress-non-favorite-game.svg
// module id = 815
// module chunks = 7